module.exports = __webpack_public_path__ + "img/stripe-credit-cards.e013010d.png";